import React from "react";

import Actions from "./Actions";
import Pagination from "./Pagination";

export default class extends React.Component {
  render() {
    const { hasSelection } = this.props;
    return (
      <div className="footer">
        <Pagination {...this.props} />
        {hasSelection && <Actions {...this.props} />}
      </div>
    );
  }
}
